
import { BaseAjaxSave } from "../../../../assets/js/common/shared_service";

export default class CreateInvoices{

    constructor(){
        this.invoiceCreateForm = document.querySelector('#invoicesCreateForm');
        if (!this.invoiceCreateForm) return;
        this.events();
    }

    events(){
        this.invoiceCreateForm.addEventListener('submit', (event) => {
            event.preventDefault();
            BaseAjaxSave(event);
        });
    }

}